import React, { useState, useEffect, useRef } from "react";
import { slugify } from "../../utilities/slugify";
import { db } from "../../fbserve";
import type { Artwork } from "../../lib/myTypes";
import {
  collection,
  doc,
  updateDoc,
  addDoc,
  deleteDoc,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import EditForm from "../template/EditForm";
import AddArtForm from "./add/AddArtForm";

// **********Edit ARTWORKS Component*******
const EditArtworks = () => {
  const artworksRef = collection(db, "artwork");
  const q = query(artworksRef, orderBy("artorder", "desc"));

  const [art, setArtworks] = useState([] as Array<any> | null);
  const [showArtList, setShowArtList] = useState(false);
  const [showAddArt, setShowAddArt] = useState(false);
  const [editArt, setEditArt] = useState(false);
  const [redEdited, setRedEdited] = useState(true);
  const [deleted, setDeleted] = useState(false);
  const [artIndex, setArtIndex] = useState(0);

  // edit artwork Ref values
  const artistFormRef = useRef<HTMLFormElement>(null);
  const artistRef = useRef<HTMLInputElement>(null);
  const artavailableFormRef = useRef<HTMLFormElement>(null);
  const artavailableRef = useRef<HTMLInputElement>(null);
  const artcategoryFormRef = useRef<HTMLFormElement>(null);
  const artcategoryRef = useRef<HTMLSelectElement>(null);
  const heightFormRef = useRef<HTMLFormElement>(null);
  const heightRef = useRef<HTMLInputElement>(null);
  const fullUploadFormRef = useRef<HTMLFormElement>(null);
  const fullUploadRef = useRef<HTMLInputElement>(null);
  const colourFormRef = useRef<HTMLFormElement>(null);
  const colourRef = useRef<HTMLInputElement>(null);
  const fullFormatsFormRef = useRef<HTMLFormElement>(null);
  const fullFormatsRef = useRef<HTMLSelectElement>(null);
  const fullHeightpxFormRef = useRef<HTMLFormElement>(null);
  const fullHeightpxRef = useRef<HTMLInputElement>(null);
  const imgaltFormRef = useRef<HTMLFormElement>(null);
  const imgaltRef = useRef<HTMLInputElement>(null);
  const fullImgqualityFormRef = useRef<HTMLFormElement>(null);
  const fullImgqualityRef = useRef<HTMLSelectElement>(null);
  const fullImgsrcFormRef = useRef<HTMLFormElement>(null);
  const fullImgsrcRef = useRef<HTMLInputElement>(null);
  const fullWidthpxFormRef = useRef<HTMLFormElement>(null);
  const fullWidthpxRef = useRef<HTMLInputElement>(null);
  const fullWidththumbFormRef = useRef<HTMLFormElement>(null);
  const fullWidththumbRef = useRef<HTMLInputElement>(null);
  const artincludeFormRef = useRef<HTMLFormElement>(null);
  const artincludeRef = useRef<HTMLInputElement>(null);
  const keyidFormRef = useRef<HTMLFormElement>(null);
  const keyidRef = useRef<HTMLInputElement>(null);
  const mediumFormRef = useRef<HTMLFormElement>(null);
  const mediumRef = useRef<HTMLSelectElement>(null);
  const artmetadescriptionFormRef = useRef<HTMLFormElement>(null);
  const artmetadescriptionRef = useRef<HTMLInputElement>(null);
  const artorderFormRef = useRef<HTMLFormElement>(null);
  const artorderRef = useRef<HTMLInputElement>(null);
  const priceFormRef = useRef<HTMLFormElement>(null);
  const priceRef = useRef<HTMLInputElement>(null);
  const slugFormRef = useRef<HTMLFormElement>(null);
  const slugRef = useRef<HTMLInputElement>(null);
  const subjectFormRef = useRef<HTMLFormElement>(null);
  const subjectRef = useRef<HTMLSelectElement>(null);
  const textFormRef = useRef<HTMLFormElement>(null);
  const textRef = useRef<HTMLTextAreaElement>(null);
  const titleFormRef = useRef<HTMLFormElement>(null);
  const titleRef = useRef<HTMLInputElement>(null);
  const typeFormRef = useRef<HTMLFormElement>(null);
  const typeRef = useRef<HTMLSelectElement>(null);
  const widthFormRef = useRef<HTMLFormElement>(null);
  const widthRef = useRef<HTMLInputElement>(null);
  const yearFormRef = useRef<HTMLFormElement>(null);
  const yearRef = useRef<HTMLInputElement>(null);
  //add form Ref values
  const addFormRef = useRef<HTMLFormElement>(null);
  const addTitleRef = useRef<HTMLInputElement>(null);
  const addCategoryRef = useRef<HTMLSelectElement>(null);
  const addKeyidRef = useRef<HTMLInputElement>(null);
  const addartorderRef = useRef<HTMLInputElement>(null);

  const getArtworks = async () => {
    const artworks = [] as Array<any>;
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc: any) => {
      artworks?.push({ ...doc.data(), id: doc.id });
    }) as unknown as Artwork;
    setArtworks(
      artworks.sort((a, b) => a.artcategory.localeCompare(b.artcategory)),
    );
  };

  useEffect(() => {
    getArtworks();
  });

  useEffect(() => {
    setRedEdited(true);
  }, [redEdited]);

  const setEditArtClose = () => {
    setEditArt(false);
    setRedEdited(false);
  };

  const artEditCard = (i: number) => {
    const nextState = i;
    setEditArt(true);
    setArtIndex(nextState);
  };

  const startArtList = () => {
    setShowArtList((prev) => !prev);
    setShowAddArt(false);
  };

  const startAddArt = () => {
    setShowAddArt((prev) => !prev);
    setShowArtList(false);
  };

  const addArtwork = (ev: any) => {
    ev.preventDefault();
    const iartorder = addartorderRef.current?.value as string;
    addDoc(artworksRef, {
      artavailable: true,
      artcategory: addCategoryRef!.current!.value,
      artinclude: true,
      artist: "Jocelyn Ball-Hansen",
      arttitle: addTitleRef.current?.value,
      keyid: addKeyidRef.current?.value,
      medium: "Acrylic",
      subject: "still life",
      artorder: parseInt(iartorder),
      slug: `${slugify(addCategoryRef!.current!.value.toString())}${slugify(
        addTitleRef!.current!.value.toString(),
      )}`,
      type: "painting",
      formats: ["avif", "webp"],
      widthpx: 900,
      heightpx: 900,
      widththumb: 450,
      imgquality: 85,
      colour: "50, 50%, 50%",
    })
      .then(() => {
        addFormRef.current!.reset();
        getArtworks();
      })
      .catch((error) => console.log(error.message));
  };

  const delArtwork = async (id: string) => {
    const confirmDel = window.confirm(
      `This cannot be undone: Are You Sure You Want to Delete ${art?.[artIndex]?.arttitle} Artwork Entry?`,
    );
    if (confirmDel) {
      setDeleted(true);
      setRedEdited(false);
      deleteDoc(doc(db, "artwork", `${id}`));
      const setTime = setTimeout(() => {
        setDeleted(false);
        getArtworks();
      }, 3300);
      return () => {
        clearTimeout(setTime);
      };
    }
  };

  const storage = getStorage();
  const urlArr: Array<any> = [];
  const uploadImg = async (ev: any, id: string, refForm: any, refInpt: any) => {
    ev.preventDefault();
    const inptVal = refInpt.current?.files;
    const inptName = refInpt.current?.name;
    const inptForm = refForm.current;
    const artRef = doc(db, "artwork", id);
    if (inptVal.length < 1 && inptVal.length > 1) {
      alert("Please Select Only One Image File");
      setRedEdited(false);
      inptForm.className = `${redEdited ? "editform red" : "editform"}`;
      inptForm!.reset();
      return;
    } else if (inptVal.length === 1) {
      for (let i: number = 0; i < inptVal!.length; i++) {
        const artimagesRef = ref(storage, `art/${inptVal![i].name}`);
        await uploadBytes(artimagesRef, inptVal![i]);
        await getDownloadURL(artimagesRef)
          .then((url) => {
            if (url as unknown as string) {
              urlArr.push(url);
            }
          })
          .catch((error: any) => {
            console.log("Error Getting Img URLs!", error.message);
          });
      }
      await updateDoc(artRef, { [`${inptName}`]: urlArr[0].toString() });
      setRedEdited(true);
      inptForm.className = `${redEdited ? "editform red" : "editform"}`;
      inptForm!.reset();
      await getArtworks();
    }
  };

  const runEdit = async (
    ev: any,
    id: string,
    refForm: any,
    refInpt: any,
    iTitle: string,
    iCategory: string,
  ) => {
    ev.preventDefault();
    setRedEdited((prev) => !prev);
    let inptVal = refInpt.current?.value;
    const inptName = refInpt.current?.name;
    const inptForm = refForm.current;
    if (
      inptName === "artorder" ||
      inptName.includes("heightpx") ||
      inptName.includes("widthpx") ||
      inptName.includes("imgquality") ||
      inptName.includes("widththumb")
    ) {
      inptVal = parseInt(inptVal);
    }
    if (inptName === "artavailable" || inptName === "artinclude") {
      inptVal = refInpt.current?.checked ? true : false;
    }
    if (inptName.includes("formats")) {
      const opts = inptForm.children[1].selectedOptions!;
      const catOptions = [];
      for (const option of opts) {
        if (option.selected) {
          catOptions.push(option.value);
        }
      }
      inptVal = catOptions;
    }
    if (inptName === "artist") {
      inptVal = "Jocelyn Ball-Hansen";
    }
    if (inptName === "slug") {
      inptVal = `${slugify(iCategory)}${slugify(iTitle)}`;
    }
    const artRef = doc(db, "artwork", id);
    if (inptName === "arttitle") {
      getArtworks();
      await updateDoc(artRef, {
        slug: `${slugify(iCategory)}${slugify(inptVal)}`,
      });
      setRedEdited(true);
      slugFormRef!.current!.className = `${
        redEdited ? "editform red" : "editform"
      }`;
    }
    await updateDoc(artRef, { [`${inptName}`]: inptVal });
    setRedEdited(true);
    refForm.current.className = `${redEdited ? "editform red" : "editform"}`;
    refForm.current!.reset();
    getArtworks();
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          borderBottom: "1px solid white",
          marginBottom: "1rem",
        }}
      >
        <button className="btn btnheading" onClick={startArtList}>
          {showArtList ? `Hide Artworks` : `Show Artworks`}
        </button>
      </div>
      {editArt ? (
        <div className="editdiv">
          <h4 style={{ marginTop: "0.5rem", marginBottom: "0" }}>
            {deleted ? (
              <span style={{ color: "red" }}>Deleted!</span>
            ) : (
              "Editing:"
            )}{" "}
            {art?.[artIndex]?.arttitle}
          </h4>
          <div
            style={{
              borderBottom: "1px solid white",
              marginBottom: "1rem",
              paddingBottom: "1rem",
            }}
          >
            <p>Image:</p>
            <EditForm
              fRef={fullUploadFormRef}
              iRef={fullUploadRef}
              fname="imgsrc"
              ftype="file"
              detfull="full"
              aIndexName={art?.[artIndex]?.imgsrc}
              onSubmit={(ev) =>
                uploadImg(
                  ev,
                  art?.[artIndex]?.id,
                  fullUploadFormRef,
                  fullUploadRef,
                )
              }
            />
            <EditForm
              fRef={colourFormRef}
              iRef={colourRef}
              fname="colour"
              ftype="text"
              detfull="full"
              aIndexName={art?.[artIndex]?.colour}
              onSubmit={(ev) =>
                runEdit(
                  ev,
                  art?.[artIndex]?.id,
                  colourFormRef,
                  colourRef,
                  art?.[artIndex]?.arttitle,
                  art?.[artIndex]?.artcategory,
                )
              }
            />
            <EditForm
              fRef={fullFormatsFormRef}
              sRef={fullFormatsRef}
              fname="formats"
              iselect={true}
              detfull="full"
              isize={2}
              ioptions={["avif", "webp", "png", "jpg", "gif", "svg"]}
              aIndexName={
                art?.[artIndex]?.formats ? art?.[artIndex]?.formats : null
              }
              onSubmit={(ev) =>
                runEdit(
                  ev,
                  art?.[artIndex]?.id,
                  fullFormatsFormRef,
                  fullFormatsRef,
                  art?.[artIndex]?.arttitle,
                  art?.[artIndex]?.artcategory,
                )
              }
            />
            <EditForm
              fRef={fullHeightpxFormRef}
              iRef={fullHeightpxRef}
              fname="heightpx"
              ftype="text"
              detfull="full"
              aIndexName={art?.[artIndex]?.heightpx}
              onSubmit={(ev) =>
                runEdit(
                  ev,
                  art?.[artIndex]?.id,
                  fullHeightpxFormRef,
                  fullHeightpxRef,
                  art?.[artIndex]?.arttitle,
                  art?.[artIndex]?.artcategory,
                )
              }
            />
            <EditForm
              fRef={imgaltFormRef}
              iRef={imgaltRef}
              fname="imgalt"
              ftype="text"
              detfull="full"
              aIndexName={art?.[artIndex]?.imgalt}
              onSubmit={(ev) =>
                runEdit(
                  ev,
                  art?.[artIndex]?.id,
                  imgaltFormRef,
                  imgaltRef,
                  art?.[artIndex]?.arttitle,
                  art?.[artIndex]?.artcategory,
                )
              }
            />
            <EditForm
              fRef={fullImgqualityFormRef}
              sRef={fullImgqualityRef}
              fname="imgquality"
              detfull="full"
              iselect={true}
              isize={1}
              ioptions={[90, 85, 80, 75]}
              aIndexName={
                art[artIndex].imgquality! ? art?.[artIndex]?.imgquality : null
              }
              onSubmit={(ev) =>
                runEdit(
                  ev,
                  art?.[artIndex]?.id,
                  fullImgqualityFormRef,
                  fullImgqualityRef,
                  art?.[artIndex]?.arttitle,
                  art?.[artIndex]?.artcategory,
                )
              }
            />
            <EditForm
              fRef={fullImgsrcFormRef}
              iRef={fullImgsrcRef}
              fname="imgsrc"
              ftype="text"
              detfull="full"
              aIndexName={art?.[artIndex]?.imgsrc}
              onSubmit={(ev) =>
                runEdit(
                  ev,
                  art?.[artIndex]?.id,
                  fullImgsrcFormRef,
                  fullImgsrcRef,
                  art?.[artIndex]?.arttitle,
                  art?.[artIndex]?.artcategory,
                )
              }
            />
            <EditForm
              fRef={fullWidthpxFormRef}
              iRef={fullWidthpxRef}
              fname="widthpx"
              ftype="text"
              detfull="full"
              aIndexName={art?.[artIndex]?.widthpx}
              onSubmit={(ev) =>
                runEdit(
                  ev,
                  art?.[artIndex]?.id,
                  fullWidthpxFormRef,
                  fullWidthpxRef,
                  art?.[artIndex]?.arttitle,
                  art?.[artIndex]?.artcategory,
                )
              }
            />
            <EditForm
              fRef={fullWidththumbFormRef}
              iRef={fullWidththumbRef}
              fname="widththumb"
              ftype="text"
              detfull="full"
              aIndexName={art?.[artIndex]?.widththumb}
              onSubmit={(ev) =>
                runEdit(
                  ev,
                  art?.[artIndex]?.id,
                  fullWidththumbFormRef,
                  fullWidththumbRef,
                  art?.[artIndex]?.arttitle,
                  art?.[artIndex]?.artcategory,
                )
              }
            />
          </div>
          <EditForm
            fRef={artistFormRef}
            iRef={artistRef}
            fname="artist"
            ftype="text"
            aIndexName={art?.[artIndex]?.artist}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                artistFormRef,
                artistRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <EditForm
            fRef={artavailableFormRef}
            iRef={artavailableRef}
            fname="artavailable"
            ftype="checkbox"
            aIndexName={art?.[artIndex]?.artavailable}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                artavailableFormRef,
                artavailableRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <EditForm
            fRef={artcategoryFormRef}
            sRef={artcategoryRef}
            fname="artcategory"
            iselect={true}
            isize={1}
            ioptions={["acrylic", "oil", "life drawing", "watercolour"]}
            aIndexName={art?.[artIndex]?.artcategory}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                artcategoryFormRef,
                artcategoryRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <EditForm
            fRef={heightFormRef}
            iRef={heightRef}
            fname="height"
            ftype="text"
            aIndexName={art?.[artIndex]?.height}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                heightFormRef,
                heightRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <EditForm
            fRef={artincludeFormRef}
            iRef={artincludeRef}
            fname="artinclude"
            ftype="checkbox"
            aIndexName={art?.[artIndex]?.artinclude}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                artincludeFormRef,
                artincludeRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <EditForm
            fRef={textFormRef}
            tRef={textRef}
            fname="text"
            ftype="text"
            aIndexName={art?.[artIndex]?.arttexthtml}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                textFormRef,
                textRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <EditForm
            fRef={titleFormRef}
            iRef={titleRef}
            fname="title"
            ftype="text"
            aIndexName={art?.[artIndex]?.arttitle}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                titleFormRef,
                titleRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <EditForm
            fRef={keyidFormRef}
            iRef={keyidRef}
            fname="keyid"
            ftype="text"
            aIndexName={art?.[artIndex]?.keyid}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                keyidFormRef,
                keyidRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <EditForm
            fRef={artorderFormRef}
            iRef={artorderRef}
            fname="artorder"
            ftype="text"
            aIndexName={art?.[artIndex]?.artorder}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                artorderFormRef,
                artorderRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <EditForm
            fRef={mediumFormRef}
            sRef={mediumRef}
            fname="medium"
            iselect={true}
            isize={1}
            ioptions={[
              "Acrylic",
              "Charcoal",
              "Conte",
              "Oil",
              "Pencil",
              "Watercolour",
            ]}
            aIndexName={art?.[artIndex]?.medium}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                mediumFormRef,
                mediumRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <EditForm
            fRef={artmetadescriptionFormRef}
            iRef={artmetadescriptionRef}
            fname="artmetadescription"
            ftype="text"
            aIndexName={art?.[artIndex]?.artmetadescription}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                artmetadescriptionFormRef,
                artmetadescriptionRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <EditForm
            fRef={priceFormRef}
            iRef={priceRef}
            fname="price"
            ftype="text"
            aIndexName={art?.[artIndex]?.price}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                priceFormRef,
                priceRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <EditForm
            fRef={slugFormRef}
            iRef={slugRef}
            fname="slug"
            ftype="text"
            aIndexName={art?.[artIndex]?.slug}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                slugFormRef,
                slugRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <EditForm
            fRef={subjectFormRef}
            sRef={subjectRef}
            fname="subject"
            iselect={true}
            isize={1}
            ioptions={[
              "Animal",
              "Landscape",
              "Still Life",
              "Figure",
              "Portrait",
              "Pet Portrait",
            ]}
            aIndexName={art?.[artIndex]?.subject}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                subjectFormRef,
                subjectRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <EditForm
            fRef={typeFormRef}
            sRef={typeRef}
            fname="type"
            iselect={true}
            isize={1}
            ioptions={["painting", "drawing"]}
            aIndexName={art?.[artIndex]?.type}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                typeFormRef,
                typeRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <EditForm
            fRef={widthFormRef}
            iRef={widthRef}
            fname="width"
            ftype="text"
            aIndexName={art?.[artIndex]?.width}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                widthFormRef,
                widthRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <EditForm
            fRef={yearFormRef}
            iRef={yearRef}
            fname="year"
            ftype="text"
            aIndexName={art?.[artIndex]?.artyear}
            onSubmit={(ev) =>
              runEdit(
                ev,
                art?.[artIndex]?.id,
                yearFormRef,
                yearRef,
                art?.[artIndex]?.arttitle,
                art?.[artIndex]?.artcategory,
              )
            }
          />
          <div style={{ display: "flex", alignItems: "baseline" }}>
            <p>ID: {art?.[artIndex]?.id}</p>
            <button
              className="btn"
              onClick={() => delArtwork(art?.[artIndex]?.id)}
            >
              Delete
            </button>
          </div>
          <button className="btn" onClick={setEditArtClose}>
            Close
          </button>
        </div>
      ) : null}
      {showAddArt ? (
        <AddArtForm
          onSubmit={(ev) => {
            addArtwork(ev);
          }}
          fRef={addFormRef}
          iTRef={addTitleRef}
          iCRef={addCategoryRef}
          iKRef={addKeyidRef}
          iORef={addartorderRef}
        />
      ) : null}
      {showArtList ? (
        <>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {art?.map((artwork, i: number) => (
              <button
                key={i}
                style={{
                  margin: "0.36rem",
                  display: "flex",
                  flexDirection: "column",
                }}
                className="btn"
                onClick={() => {
                  artEditCard(i);
                }}
              >
                <span>{artwork.arttitle}</span>
                <span>
                  <small>
                    {artwork.artcategory}: {artwork.artorder}
                  </small>
                </span>
              </button>
            ))}
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              borderBottom: "1px solid white",
              marginBottom: "1rem",
            }}
          >
            <button className="btn btnheading" onClick={startAddArt}>
              {showAddArt ? `Hide Add Art` : `Show Add Art`}
            </button>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default EditArtworks;
